import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GenericDaterangeInputModule, GenericSelectInputModule } from '@sla-ng/ui-material';
import { PurchasePage } from './purchase.page';

export * from './purchase.page';

const routes: Routes = [
    {
        path: '',
        component: PurchasePage,
    },
];

@NgModule({
    declarations: [ PurchasePage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatMomentDateModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MatPaginatorModule,
        GenericDaterangeInputModule,
        ReactiveFormsModule,
        MatSortModule,
        MatTooltipModule,
        MatSelectModule,
        GenericSelectInputModule,
        MatDateRangeInput,
        MatDateRangePicker,
        MatDatepickerToggle,
        MatEndDate,
        MatStartDate,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class PurchasePageModule {
}
